var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRenewable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_1596",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 161
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.0312,
    r: 80,
    fill: "#5D38E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_1596)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.0312,
    r: 80,
    fill: "#DED6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.9 44.4609C115.764 51.8803 123.122 64.0693 123.978 78.0112",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3726 78.1941C37.1675 64.1706 44.5461 51.9001 55.451 44.4399",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5709 135.634C52.2917 133.453 47.3794 130.538 42.9971 127.012",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.354 127.012C113.053 130.477 108.243 133.351 103.086 135.511",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.905 25.0356C123.489 33.4334 139.571 55.2024 139.571 80.7014C139.571 84.4519 139.225 88.1004 138.572 91.647",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7986 91.6674C21.1463 88.1208 20.7998 84.4519 20.7998 80.7218C20.7998 55.2024 36.8819 33.4538 59.4662 25.0356",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5146 81.5461V160.031",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.5998,
    cy: 80.0312,
    r: 12.8,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5742 23.2313H85.4558C85.7579 23.2313 86.0059 23.4703 86.0171 23.7721L87.8876 74.1211C87.8995 74.4393 87.6447 74.7036 87.3263 74.7036H75.7037C75.3853 74.7036 75.1305 74.4393 75.1423 74.1211L77.0129 23.7721C77.0241 23.4703 77.2721 23.2313 77.5742 23.2313Z",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9087 112.921L28.6235 105.498C28.4727 105.237 28.5551 104.903 28.8103 104.742L71.1679 78.0212C71.4376 77.851 71.7946 77.9393 71.954 78.2154L78.2017 89.0367C78.3611 89.3128 78.259 89.6661 77.9768 89.8146L33.6567 113.137C33.3898 113.277 33.0595 113.182 32.9087 112.921Z",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.902 112.921L133.188 105.498C133.338 105.237 133.256 104.903 133.001 104.742L111.724 91.3198L90.6431 78.0212C90.3735 77.851 90.0164 77.9393 89.857 78.2154L83.6093 89.0367C83.4499 89.3128 83.552 89.6661 83.8342 89.8146L128.154 113.137C128.421 113.277 128.751 113.182 128.902 112.921Z",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRenewable);
export default __webpack_public_path__ + "static/media/icon_renewable.c9d87df4db76166f1b4c111bcccc0a41.svg";
export { ForwardRef as ReactComponent };